export default "__VITE_ASSET__S3BJIKV$__"